import { isDefined } from "@pharmupp/p3-front-commons"
import type { LoyaltyProgramData } from "./loyaltyProgram.model"

export const hasLoyaltyProgramData = (loyaltyData: LoyaltyProgramData) =>
  [
    loyaltyData.numCardHolders,
    loyaltyData.averageBasketWithoutCheques,
    loyaltyData.averageBasketWithCheques,
    loyaltyData.loyaltyChequesCashingRate,
    loyaltyData.saleStats?.mainStat,
    loyaltyData.visitorStats?.mainStat,
  ].some(isDefined)
